export const tasksRouteNames = {
  default: 'tasks-v2',
}
